import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Registra Service Worker e gestisci aggiornamenti automatici
if ('serviceWorker' in navigator) {

  // ── Valvola di emergenza: ?reset=sw azzera tutto ─────────────────────────
  if (window.location.search.includes('reset=sw')) {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      Promise.all(regs.map((r) => r.unregister()))
        .then(() => caches.keys())
        .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
        .then(() => {
          const clean = window.location.href.replace(/[?&]reset=sw/, '').replace(/[?&]$/, '');
          window.location.replace(clean);
        });
    });
  } else {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then((reg) => {
        // Controlla aggiornamenti immediatamente all'avvio
        reg.update();

        // E ogni volta che la pagina torna in focus
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') reg.update();
        });

        // Se c'è già un nuovo SW in attesa, attivalo subito
        if (reg.waiting) {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        }

        // Nuovo SW trovato: appena installato, attivalo subito
        reg.addEventListener('updatefound', () => {
          const newSW = reg.installing;
          if (!newSW) return;
          newSW.addEventListener('statechange', () => {
            if (newSW.state === 'installed') {
              newSW.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      });

      // Ricarica automaticamente quando il SW segnala una nuova versione
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'SW_UPDATED') {
          window.location.reload();
        }
      });
    });
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
